import CustomStore from 'devextreme/data/custom_store';
import { ref } from 'vue';
import useGraphTooltipRepository from '@/modules/masterData/cmsGraphTooltips/repositories/graphTooltip.repository.js';
import store from '@/store/index';

export default function useDatagrid() {
  const graphTooltipRepostory = useGraphTooltipRepository();
  const datasource = ref();

  const getDatasource = (supplierId) => {
    datasource.value = new CustomStore({
      key: 'id',
      load: (loadOptions) => graphTooltipRepostory.load(loadOptions, supplierId)
        .then((response) => ({
          data: response.data.data,
          totalCount: response.data.totalCount,
          summary: response.data.summary,
          groupCount: response.data.groupCount,
        })),
      update: (key, values) => new Promise((resolve, reject) => {
        graphTooltipRepostory.update(key, values)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Dine ændringer er gemt');
              resolve(response);
            } else {
              if (response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
      insert: (values) => new Promise((resolve, reject) => {
        graphTooltipRepostory.insert(values)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Graf Tooltip er nu oprettet');
              resolve(response);
            } else {
              if (response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
      remove: (key) => new Promise((resolve, reject) => {
        graphTooltipRepostory.remove(key)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Graf Tooltip er nu slettet');
              resolve(response);
            } else {
              if (response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
    });
  };

  const onInitNewRow = (e, supplierId) => {
    // Set default value
    e.data.supplierId = supplierId;
  };

  return {
    datasource,
    getDatasource,
    onInitNewRow,
  };
}
